var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationArrowRight({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6981 11.1913L10.387 5.34149C10.1916 5.11394 9.94736 5 9.65376 5C9.36015 5 9.1162 5.11394 8.92046 5.34149L8.30159 6.01535C8.10072 6.23725 8 6.50667 8 6.82424C8 7.14181 8.10044 7.4084 8.30159 7.64194L12.2605 12.0002L8.30131 16.3675C8.10044 16.5891 8 16.8585 8 17.1761C8 17.4936 8.10044 17.7602 8.30131 17.9938L8.92046 18.6676C9.12134 18.8892 9.36586 19 9.65376 19C9.94165 19 10.1862 18.8892 10.387 18.6676L15.6984 12.8179C15.8996 12.5843 16 12.3118 16 12.0002C16 11.6826 15.8993 11.4132 15.6984 11.1913H15.6981Z"
  })));
}

export default SvgPaginationArrowRight;